<template>
    <Modal :alwaysShow="true" header="Inventory Item" @shown="shown" @hide="$emit('hide')">
        <div v-if="!item">
            <em>Loading...</em>
        </div>
        <div v-else>
            <h4>{{ item.title }}</h4>
            <h5>{{ item.author }}</h5>

            <hr />

            <div>
                <strong>Quantity:</strong>
                {{ item.quantity | numberFormat }}
            </div>
            <div>
                <strong>Price:</strong>
                ${{ item.price | numberFormat(2) }}
            </div>
            <div v-if="item.amazon_product && item.amazon_product.publication_date">
                <strong>Publication Date:</strong>
                {{ item.amazon_product.publication_date | date.utc }}
            </div>
            <div v-if="item.amazon_product && item.amazon_product.release_date">
                <strong>Release Date:</strong>
                {{ item.amazon_product.release_date | date.utc }}
            </div>

            <div v-if="item.amazon_product && item.amazon_product.lowest_offer_listings">
                <hr />
                <h5>Lowest Offers</h5>

                <div class="nl2br">{{ item.amazon_product.lowest_offer_listings.short_summary }}</div>
            </div>

            <div v-if="item.order_items.length">
                <hr />
                <h5>Previous Orders</h5>

                <OrderItemsTable :orderItemIds="item.order_items" />
            </div>

            <div v-if="item.other_vendor_items.length">
                <hr />
                <h5>Other Vendors</h5>

                <table class="table">
                    <thead>
                        <tr>
                            <th>Vendor</th>
                            <th class="text-right">Quantity</th>
                            <th class="text-right">Price</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="otherItem in item.other_vendor_items" :key="otherItem.id">
                            <td>{{ otherItem.vendor.name }}</td>
                            <td class="text-right">{{ otherItem.quantity | numberFormat }}</td>
                            <td class="text-right">${{ otherItem.price | numberFormat(2) }}</td>
                            <td class="text-right">
                                <AddToOrder
                                    v-if="otherItem.current_inventory_item_id"
                                    :vendor-id="otherItem.vendor_id"
                                    :product-id="otherItem.product_id"
                                    :inventory-item-id="otherItem.current_inventory_item_id"
                                    only-show-this-vendor
                                    />
                                <router-link :to="`/vendors/${otherItem.vendor.id}/inventory?search=${item.product.ean}`" target="_blank" class="btn btn-xs btn-default">
                                    <i class="fa fa-search"></i>
                                    View
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="item.product.bans.length">
                <hr />
                <h5>Product Notes/Bans</h5>

                <ProductBanRow
                    v-for="ban in item.product.bans"
                    :key="ban.id"
                    :productBan="ban"
                    @deleted="loadData"
                    />
            </div>
        </div>
    </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import OrderItemsTable from '@/components/orderitems/OrderItemsTable';

export default {
    components: {
        OrderItemsTable,
        ProductBanRow: require('./ProductBanRow.vue').default,
    },
    props: ['id'],
    computed: {
        ...mapState('data', {
            item(data) {
                return data.vendorInventoryItems.byId[this.id];
            },
            orderStatuses(data) {
                return data.orders.statuses;
            },
        }),
    },
    methods: {
        ...mapActions('data', ['getVendorInventoryItem']),
        shown() {
            this.loadData();
        },
        loadData() {
            return this.getVendorInventoryItem({ id: this.id });
        },
    },
};
</script>
